import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12.001 6h1.5m3 0h1.5m-6 6h1.5m3 0h1.5m-6 3v6m-7.5 0h15M21 6a3 3 0 0 1-3 3H6a3 3 0 1 1 0-6h12a3 3 0 0 1 3 3"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 12a3 3 0 0 1-3 3H6a3 3 0 1 1 0-6h12a3 3 0 0 1 3 3"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      d: "M6.751 6.375a.375.375 0 1 1 0-.75m0 .75a.375.375 0 0 0 0-.75m0 6.75a.375.375 0 1 1 0-.75m0 .75a.375.375 0 1 0 0-.75M1.126 21a.375.375 0 1 1 0-.75m0 .75a.375.375 0 1 0 0-.75m21.75.75a.375.375 0 1 1 0-.75m0 .75a.375.375 0 1 0 0-.75"
    }, null, -1)
  ]));
}
const programmingComputerDatabaseServer = { render };
export {
  programmingComputerDatabaseServer as default,
  render
};
//# sourceMappingURL=programming-computer-database-server.svg.js.map
